import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import cacheManager from '../../CacheManager';

const LayoutMenu = ({ clienteNome }) => {
    const navigate = useNavigate();

    const handleLogout = () => {
        // Limpa o cache
        cacheManager.clearSession();
        // Limpa o localStorage
        localStorage.removeItem('clienteSession');
        // Redireciona para login
        navigate('/login');
        // Força reload para limpar o estado
        window.location.reload();
    };

    return (
        <nav className="navbar navbar-expand-lg navbar-light shadow-sm" style={{ backgroundColor: '#27355c' }}>
            <div className="container">
                <Link className="navbar-brand" to="/meus-agendamentos">
                    <img src="/coworking-itaguai-1.png" alt="Logo" width="180" />
                </Link>
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                    style={{ backgroundColor: 'white' }}
                >
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav ms-auto">
                        <li className="nav-item" style={{ display: 'none' }}>
                            <Link to="/dashboard" className="nav-link" style={{ color: 'white' }}>
                                Dashboard
                            </Link>
                        </li>
                        <li className="nav-item" style={{ display: 'none' }}>
                            <Link to="/agenda" className="nav-link" style={{ color: 'white' }}>
                                Agenda
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/novo-agendamento" className="nav-link" style={{ color: 'white' }}>
                                Novo Agendamento
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/meus-agendamentos" className="nav-link" style={{ color: 'white' }}>
                                Meus Agendamentos
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/termos-de-uso" className="nav-link" style={{ color: 'white' }}>
                                Termos de Uso
                            </Link>
                        </li>
                        <li className="nav-item" style={{ display: 'none' }}>
                            <Link to="/minhas-faturas" className="nav-link" style={{ color: 'white' }}>
                                Minhas Faturas
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/meu-perfil" className="nav-link" style={{ color: 'white' }}>
                                {clienteNome || 'Usuário'}
                            </Link>
                        </li>
                        <li className="nav-item">
                            <button 
                                className="btn btn-outline-light btn-sm"
                                onClick={handleLogout}
                                style={{ marginLeft: '10px' }}
                            >
                                Sair
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default LayoutMenu;
